import { cn } from '../../cn/cn';

export type AppSpinnerSize = 'xs' | 'sm' | 'lg';

/**
 * 12px inline in text, 16px over a button label, 40px alone on a screen. No
 * `md`: nothing uses 24px.
 */
const SIZES: Record<AppSpinnerSize, string> = {
  xs: 'size-3',
  sm: 'size-4',
  lg: 'size-10',
};

/**
 * Stroked with `currentColor`, so callers recolour it with a `text-*` class.
 * `text-primary` is the default for a standalone spinner.
 */
const BASE = 'inline-block animate-spin text-primary';

export const appSpinnerClasses = ({
  size,
  className,
}: {
  size: AppSpinnerSize;
  className?: string;
}): string => cn(BASE, SIZES[size], className);
